export const CREATE_BUDGET_SUCCESSFUL = 'CREATE_BUDGET_SUCCESSFUL';
export const CREATE_BUDGET_FAIL = 'CREATE_BUDGET_FAIL';

export const UPDATE_BUDGET_SUCCESSFUL = 'UPDATE_BUDGET_SUCCESSFUL';
export const UPDATE_BUDGET_FAIL = 'UPDATE_BUDGET_FAIL';

export const PULL_BACK_SUCCESSFUL = 'PULL_BACK_SUCCESSFUL';
export const PULL_BACK_FAIL = 'PULL_BACK_FAIL';
